import { useState } from "react";
import ChatScreen      from "./components/ChatScreen";
import SubsidyScreen   from "./components/SubsidyScreen";
import HomeScreen      from "./components/HomeScreen";
import ProScreen       from "./components/ProScreen";
import TutorialScreen  from "./components/TutorialScreen";
import HelpScreen      from "./components/HelpScreen";
import FarmScreen      from "./components/FarmScreen";
import { PREFECTURES, CATEGORY_COLORS } from "./data/subsidies";
import "./App.css";

const TABS = [
  { id: "home",    icon: "🏠", label: "ホーム" },
  { id: "chat",    icon: "💬", label: "AIに相談" },
  { id: "subsidy", icon: "📋", label: "補助金" },
  { id: "farm",    icon: "📒", label: "帳簿・農地" },
  { id: "pro",     icon: "👨‍💼", label: "士業に頼む" },
];

const TUTORIAL_KEY = "nouen_tutorial_done";

// 外から条件つきで開けるようにする（例: /?goal=設備投資&pref=茨城県）。
// LINEのメニューや補助金ナビから「やりたいこと・県」を引き継いで、最初の質問を省くため。
function readStartParams() {
  try {
    const q = new URLSearchParams(window.location.search);
    const goal = q.get("goal");
    const pref = q.get("pref");
    return {
      goal: goal && CATEGORY_COLORS[goal] ? { category: goal, label: goal, icon: "🎯" } : null,
      pref: pref && PREFECTURES.includes(pref) ? pref : "",
    };
  } catch {
    return { goal: null, pref: "" };
  }
}
const START = readStartParams();

export default function App() {
  const [tutorialDone, setTutorialDone] = useState(
    () => localStorage.getItem(TUTORIAL_KEY) === "1"
  );
  const [tab, setTab] = useState(START.goal ? "subsidy" : "home");
  const [goal, setGoal] = useState(START.goal);
  const [showHelp, setShowHelp] = useState(false);

  const handleTutorialDone = () => {
    localStorage.setItem(TUTORIAL_KEY, "1");
    setTutorialDone(true);
  };
  const [chatInit, setChatInit] = useState("");

  const goToChat = (msg) => {
    setChatInit(msg);
    setTab("chat");
  };

  // ホームで選んだ「やりたいこと」を補助金タブに引き継ぐ（選んだ分類で最初から絞り込む）
  const goToSubsidy = (g) => {
    setGoal(g || null);
    setTab("subsidy");
  };

  return (
    <div className="shell">
      {/* ヘッダー */}
      <header className="header">
        <div className="header-left">
          <span className="logo">🌾 農援</span>
          <span className="tagline">農家の心強い味方</span>
        </div>
        <span className="header-badge">Beta</span>
      </header>

      {/* メインコンテンツ */}
      <main className="main">
        {!tutorialDone ? (
          <TutorialScreen onDone={handleTutorialDone} />
        ) : showHelp ? (
          <HelpScreen onClose={() => setShowHelp(false)} />
        ) : (
          <>
            {tab === "home"    && <HomeScreen onSelect={goToSubsidy} onChat={goToChat} onHelp={() => setShowHelp(true)} />}
            {tab === "chat"    && <ChatScreen initMessage={chatInit} onClear={() => setChatInit("")} />}
            {tab === "subsidy" && (
              <SubsidyScreen
                key={goal ? goal.category : "all"}
                goal={goal}
                startPref={START.pref}
                onChangeGoal={() => { setGoal(null); setTab("home"); }}
              />
            )}
            {tab === "farm"    && <FarmScreen onGoSubsidy={() => goToSubsidy(null)} />}
            {tab === "pro"     && <ProScreen onGoSubsidy={() => goToSubsidy(null)} />}
          </>
        )}
      </main>

      {/* ボトムナビ */}
      <nav className="bottom-nav">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`nav-btn ${tab === t.id ? "active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            <span className="nav-icon">{t.icon}</span>
            <span className="nav-label">{t.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
